import { useState } from 'react';

export function useOrganizationSteps(stepsLength: number) {
  const [currentStep, setCurrentStep] = useState(1);

  const handleNextStep = () => {
    if (currentStep < stepsLength) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  return {
    currentStep,
    handleNextStep,
    handlePrevStep,
  };
}
